// before 20-5-2026
// import { CircularProgress, Container, useTheme } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import { InsertDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { Notify } from '../Utility/Notify';
// import AddIcon from '@mui/icons-material/Add';
// import { Col } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

// export const AddDevelopers = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const dispatch = useDispatch();
//   const [name, setName] = useState('');
//   const [loading, setloading] = useState(true);
//   const [addDeveloperLoading, setAddDeveloperLoading] = useState(false);

//   //==========================================================================================
//   //on developer name change
//   const onnamechange = (e) => {
//     setName(e.target.value);
//   };

//   // ===============================================add
//   //on submite

//   const onsubmiteadddeveloper = async (e) => {
//     e.preventDefault();
//     if (name === '') {
//       Notify('error', 'Please fill the developer name', 'error');
//       return;
//     } else {
//       //add developer to database
//       setloading(true);
//       setAddDeveloperLoading(true);

//       await dispatch(InsertDevelopersData({ name }));
//       setloading(false);
//       setAddDeveloperLoading(false);
//     }
//   };

//   const resAdd = useSelector((state) => state.AllDevelopers.Developers);
//   useEffect(() => {
//     if (loading === false) {
//       if (resAdd && resAdd.data) {
//         if (resAdd.status === 201) {
//           Notify('success', 'Developer added successfully', 'success');
//           setName('');
//           setloading(true);
//           // setTimeout(() => {
//           //     window.location.href='/Developers'
//           //  }, 1500)
//         }
//       }
//     }
//   }, [loading]);

//   //=========================================================================

//   return (
//     <Container className="startpage">
//       <Row style={{ width: '100%', marginTop: '50px', borderRadius: '10px' }}>
//         <Col sm={2}></Col>

//         <Col sm={10}>
//           <div className=" d-flex justify-content-between w-100">
//             {/* <div className='d-flex '>
//             <div className='mx-4 '>Add Developer</div>
//             <a style={{textDecoration:'none'}} href='/Developers' className='goback'>{"<<"} Go Back </a>
//             </div>    */}

//             <div>
//               <Link
//                 to={
//                   userlogin?.data?.role === 'Admin'
//                     ? '/AllLeadsForAdmin'
//                     : userlogin?.data?.role === 'Marketer'
//                       ? '/ALLLeadsForMarketer'
//                       : userlogin?.data?.role === 'Accountant'
//                         ? '/LeadsForAccountant'
//                         : '/Dashboard'
//                 }
//                 style={{ textDecoration: 'none', color: '#1026ff' }}
//               >
//                 <span style={{ fontWeight: 'bold' }}>Home</span>
//               </Link>

//               <KeyboardDoubleArrowRightIcon />
//               <span style={{ color: '#666' }}>Add Developer</span>
//             </div>
//           </div>

//           <div className="d-flex flex-wrap justify-content-center" style={{ marginTop: '30px' }}>
//             <Container
//               style={{
//                 padding: '25px',
//                 background: mode === 'dark' ? '#333' : '#fff',
//                 marginTop: '30px',
//                 borderRadius: '20px',
//               }}
//             >
//               <label>Developer Name*</label>
//               <input
//                 onChange={onnamechange}
//                 value={name}
//                 className="inputsaddclient"
//                 type="text"
//                 id="name"
//                 name="firstname"
//                 placeholder="Developer name.."
//               />
//               {/* <hr/> */}
//               {/* <div onClick={onsubmiteadddeveloper}  className='addnewclient' style={{textAlign:'center',background:'#0F7687'}}  type="submit" ><AddIcon/> Add Developer</div> */}
//             </Container>
//             <div className="d-flex justify-content-center w-100">
//               <div
//                 onClick={!addDeveloperLoading ? onsubmiteadddeveloper : null}
//                 className="addnewclient"
//                 style={{
//                   textAlign: 'center',
//                   background: '#102dff',
//                   pointerEvents: addDeveloperLoading ? 'none' : 'auto',
//                   opacity: addDeveloperLoading ? 0.6 : 1,
//                   cursor: addDeveloperLoading ? 'not-allowed' : 'pointer',
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   gap: '6px',
//                   height: '40px',
//                 }}
//                 type="submit"
//               >
//                 {addDeveloperLoading ? (
//                   <CircularProgress size={20} style={{ color: 'white' }} />
//                 ) : (
//                   <>
//                     <AddIcon /> Add Developer
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };




















// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { InsertDevelopersData } from '../Redux/Actions/DevelopersAction';
import { Notify } from '../Utility/Notify';
import AddIcon from '@mui/icons-material/Add';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

export const AddDevelopers = () => {
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* ✅ sidebar sync */
  const sidebarWidth = useSidebarWidth();

  const [name,    setName]    = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const onsubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return Notify('error', 'Please fill the developer name', 'error');
    setLoading(true);
    setSending(true);
    await dispatch(InsertDevelopersData({ name: name.trim() }));
    setLoading(false);
    setSending(false);
  };

  const resAdd = useSelector((state) => state.AllDevelopers.Developers);
  useEffect(() => {
    if (loading === false) {
      if (resAdd?.status === 201) {
        Notify('success', 'Developer added successfully', 'success');
        setName('');
      }
      setLoading(true);
    }
  }, [loading]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor     = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to="/Developers" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Developers
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Add New Developer</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
              Add New Developer
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Add a new developer to the CRM database
            </p>
          </div>

          {/* field */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Developer Name *</label>
            <input
              style={inputStyle}
              value={name}
              onChange={e => setName(e.target.value)}
              type="text"
              placeholder="e.g. Emaar, Damac"
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={e => { if (e.key === 'Enter') onsubmit(e); }}
              autoFocus
            />
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full developer name as it will appear across the system
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!sending ? onsubmit : null}
              disabled={sending}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { if (!sending) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; } }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              {sending
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Adding…</span></>
                : <><AddIcon sx={{ fontSize: 17 }} /><span>Add Developer</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Developers')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8'; e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b'; }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};
